import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M15.5,18.5l-4.4,4.4c-2.6,2.6-6.8,2.8-9.3,0.3s-2.4-6.7,0.3-9.3l4.4-4.4c2.6-2.6,6.7-2.8,9.2-0.4c0,0,0,0,0.1,0.1l0,0l0,0 l0,0c0.7,0.9,0.5,2.1-0.4,2.7c-0.7,0.6-1.7,0.5-2.4,0l0,0c-1.1-1.1-3.1-1.1-4.3,0.2l-4.2,4.2c-1.2,1.2-1.3,3.2-0.1,4.4 c1.1,1.1,3.1,1.1,4.4-0.1l2.1-2.1c0.8,0.3,1.3,0.5,2,0.5C13.9,19.1,14.6,19,15.5,18.5z M23.2,1.8c-2.5-2.5-6.7-2.4-9.3,0.3L9.9,6 c0.8-0.2,1.5-0.3,2.5-0.3c0.8,0,1.4,0.3,2,0.6l1.7-1.7c1.2-1.2,3.2-1.3,4.4-0.1c1.1,1.1,1.1,3.1-0.1,4.4L16.2,13 c-1.2,1.2-3.1,1.3-4.3,0.1l0,0c-0.8-0.7-2.1-0.5-2.7,0.3c-0.5,0.7-0.6,1.5,0,2.2l0.1,0.1c2.5,2.4,6.6,2.2,9.2-0.4l4.4-4.4 C25.6,8.5,25.7,4.3,23.2,1.8z" />
    </g>
  </svg>
);
